import React, { useState, useEffect } from 'react';
import { IconButton, TextField, Modal, Typography, Box, FormControl, InputLabel, Select, MenuItem } from '@mui/material';
import AddIcon from '@mui/icons-material/Add';
import '../organizationStaff/organizationStaff.css'
import { styled } from '@mui/material/styles';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell, { tableCellClasses } from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import Paper from '@mui/material/Paper';
import { Link } from 'react-router-dom';
import axios from 'axios';


const StyledTableCell = styled(TableCell)(({ theme }) => ({
    [`&.${tableCellClasses.head}`]: {
        backgroundColor: '#169a8f',
        color: theme.palette.common.white,
        textAlign: 'center',
        fontWeight:800,
        fontSize: 16,
        fontFamily:'nunito'

    },
    [`&.${tableCellClasses.body}`]: {
        fontSize: 14,
        textAlign: 'center',
        fontFamily:'nunito'

    },
}));

const StyledTableRow = styled(TableRow)(({ theme }) => ({
    '&:nth-of-type(odd)': {
        backgroundColor: theme.palette.action.hover,
    },
    // hide last border
    '&:last-child td, &:last-child th': {
        border: 0,
    },
}));


const ActiveStudyStatus = ({ setShowSpinner, id }) => {
    const [data, setData] = useState(null);
    //Bearer Token
    const token = localStorage.getItem('token');
    const tokenValue = token ? token.slice(1, token.length - 1) : "";
    console.log(id)
    const getData = () => {
        axios.get(`https://research-mate-b35a10757d5a.herokuapp.com/api/myStudy/status/${id}`, {
            headers: {
                'Authorization': `Bearer ${tokenValue}`
                // You can add other headers if needed like authorization token, etc.
            }
        })
            .then(res => {
                const response = res.data.status
                setData(response);
            })
            .catch(error => {
                console.log(error);
            })
            .finally(() => {
                setShowSpinner(false);
            })
    }

    useEffect(() => {
        getData()
    }, [])

    return (
        <Box sx={{ p: 2, color: '#169a8f', fontWeight: 'bold' }}>
            <div className='mt-4'>
                <TableContainer component={Paper}>
                    <Table sx={{ minWidth: 700 }} aria-label="customized table">
                        <TableHead>
                            <TableRow>
                                <StyledTableCell >SMO</StyledTableCell>
                                <StyledTableCell align="right">CDA</StyledTableCell>
                                <StyledTableCell align="right">Protocol/FQ</StyledTableCell>
                                <StyledTableCell align="right">PSSV</StyledTableCell>
                                <StyledTableCell align="right">Budget/CTA</StyledTableCell>
                                <StyledTableCell align="right">SIV</StyledTableCell>
                                <StyledTableCell align="right">Invoicing</StyledTableCell>
                                <StyledTableCell align="right">All Step Clear</StyledTableCell>
                                <StyledTableCell align="right">Total</StyledTableCell>
                            </TableRow>
                        </TableHead>
                        <TableBody>
                            <StyledTableRow>
                                <StyledTableCell align="right">{data && data.smo}</StyledTableCell>
                                <StyledTableCell align="right">{data && data.cda}</StyledTableCell>
                                <StyledTableCell align="right">{data && data.protocol}</StyledTableCell>
                                <StyledTableCell align="right">{data && data.pssv}</StyledTableCell>
                                <StyledTableCell align="right">{data && data.budget}</StyledTableCell>
                                <StyledTableCell align="right">{data && data.siv}</StyledTableCell>
                                <StyledTableCell align="right">{data && data.invoicing}</StyledTableCell>
                                <StyledTableCell align="right">{data && data.allClear}</StyledTableCell>
                                <StyledTableCell align="right">{data && (
                                    data.smo +
                                    data.cda +
                                    data.protocol +
                                    data.pssv +
                                    data.budget +
                                    data.siv +
                                    data.invoicing +
                                    data.allClear 
                                )}</StyledTableCell>

                            </StyledTableRow>
                        </TableBody>
                    </Table>
                </TableContainer>
            </div>
        </Box>
    );
};

export default ActiveStudyStatus;
